import WebServiceRequest from "@/libs/Api/WebServiceRequest";

class CreateAnswerListForExam extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Answer/CreateList");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}

class GetAllAnswersForExam extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Answer/GetAll");
  }
  setRequestParam(data) {
    super.setRequestParam(data);
  }
}

class UpdateAnAnswer extends WebServiceRequest {
  constructor(context) {
    super(context);
    super.setTag("Answer/Update");
  }
  setRequestParamDataObj(data) {
    super.setRequestParamDataObj(data);
  }
}
export { CreateAnswerListForExam, GetAllAnswersForExam, UpdateAnAnswer };
